var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArchitectureActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "house-modern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STENI-pattern-generator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "choose-product-menu-open-pre",
    transform: "translate(-742.000000, -134.000000)",
    stroke: "#E13527",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-3",
    transform: "translate(698.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house-modern",
    transform: "translate(44.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.788,17.571 L23.25,17.571",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "9.773 17.571 2.286 17.571 2.286 7.838 9.773 6.341"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "21.753 17.571 9.773 17.571 9.773 1.101 21.753 6.341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.768,5.967 C12.867191,5.967 12.9623193,6.00640346 13.0324579,6.07654206 C13.1025965,6.14668067 13.142,6.24180903 13.142,6.341",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.393,6.341 C12.3935512,6.13428385 12.5612831,5.96699927 12.768,5.967",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.768,6.716 C12.5608932,6.716 12.393,6.54810678 12.393,6.341",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.142,6.341 C13.1422657,6.44036412 13.1029795,6.53574958 13.0328121,6.60610462 C12.9626447,6.67645966 12.8673645,6.71600036 12.768,6.716",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.758,17.571 L12.768,17.571 L12.768,13.079 C12.768,12.2505729 13.4395729,11.579 14.268,11.579 L17.268,11.579 C18.0964271,11.579 18.768,12.2505729 18.768,13.079 L18.758,17.571 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,8.146 L9.773,6.341",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.238,0.429 L23.246,6.994",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "18.758 5.022 18.758 1.101 21.753 1.101 21.753 6.341"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchitectureActive);
export default __webpack_public_path__ + "static/media/icon-architecture-active.3d486b765d5c2adc9f6b78f2af025c0f.svg";
export { ForwardRef as ReactComponent };